// Scroll to a section, using the Lenis instance when available so anchor
// navigation stays in sync with the smooth-scroll engine (fixes mobile taps).
export function scrollToSection(href) {
  const el =
    typeof href === "string" ? document.querySelector(href) : href;
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    const y = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
